import { type AllegatoComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/allegatoComunicazioneDTO.ts';
import { Divider, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { AttachmentItem } from './AttachmentItem.tsx';

const AttachmentsDivider = styled(Divider)`
  &.ant-divider {
    margin-top: 12px;
    margin-bottom: 6px;
  }
  .ant-divider-inner-text {
    color: ${props => props.theme.colorTextTertiary};
  }
`;

export interface ICommunicationAttachmentsProps {
  attachments: AllegatoComunicazioneDTO[] | null | undefined;
}

/**
 * Elenco degli allegati della comunicazione
 */
export function CommunicationAttachments(
  props: ICommunicationAttachmentsProps,
) {
  const { attachments } = props;
  const { t } = useTranslation();

  if (!attachments || attachments.length === 0) return null;

  return (
    <div>
      <AttachmentsDivider plain orientation="left" orientationMargin={0}>
        {t('communication-attachments.attachments', 'Allegati')}
      </AttachmentsDivider>
      <Space size={[16, 4]} wrap>
        {attachments.map(attachment => (
          <AttachmentItem
            attachment={attachment}
            key={attachment.id}
            id={attachment.id}
          />
        ))}
      </Space>
    </div>
  );
}
